<template>
  <nav>
    <button class="btn-menu" @click="toggleNav">
      <Menu />
    </button>
    <transition name="roll">
      <section class="nav-section" v-show="showNav">
        <div class="search-container">
          <select
            v-model="depth"
            class="search-option search-edge search-border depth"
          >
            <option v-for="i in 15" :key="i">{{ i }}</option>
          </select>
          <input
            v-model="input"
            placeholder="Materia"
            class="search-option search-input search-border subject"
            @keydown.enter="searchSubmit"
          />
          <button
            @click="searchSubmit"
            class="search-option search-edge submit"
          >
            <Loader v-if="loading" class="loader" />
            <MagnifyingGlass v-else class="search-icon" />
          </button>
        </div>
        <span class="logo">
          <AppLogo />
        </span>
      </section>
    </transition>
  </nav>
</template>

<script>
import MagnifyingGlass from "./svg/MagnifyingGlass.vue";
import Menu from "./svg/Menu.vue";
import AppLogo from "./svg/AppLogo.vue";
import Loader from "./Loader.vue";

export default {
  components: {
    MagnifyingGlass,
    Menu,
    AppLogo,
    Loader
  },
  data() {
    return {
      depth: "2",
      input: "Grafos",
      showNav: true
    };
  },
  methods: {
    toggleNav() {
      this.showNav = !this.showNav;
    },
    searchSubmit() {
      this.$store.commit("changeDepth", this.depth);
      this.$store.commit("changeInput", this.input);
      this.$store.dispatch("submitSearch");
    }
  },
  computed: {
    loading() {
      return this.$store.state.isSearching;
    }
  }
};
</script>

<style>
*:active {
  outline: none;
}

input:focus,
select:active,
select:focus,
button:focus,
button {
  outline: none !important;
}

.btn-menu {
  background-color: #07689f;
  box-shadow: 0 0 5px rgba(57, 63, 72, 0.3);
  @apply left-0 ml-2 fixed bottom-0
  p-2 mb-2 h-10 w-10 z-10 fill-gray-100
  rounded-full;
}

nav section {
  background-color: #07689f;
  @apply flex flex-col items-center fixed bottom-0 w-screen p-2;
}

.logo {
  height: 35px;
  @apply mt-2 mb-1;
}

.search-container {
  @apply flex flex-row bg-gray-100 rounded-full w-full;
}

.search-option {
  @apply bg-transparent;
}

.search-edge {
  @apply w-10;
}

.search-input {
  @apply w-1 flex-grow px-1;
}

.search-border {
  @apply border-r-2 border-gray-400;
}

.search-icon {
  @apply w-8 h-auto p-2 mx-auto;
}

.loader {
  @apply mx-auto;
}

.roll-enter-active {
  animation: slide 200ms;
}

.roll-leave-active {
  animation: slide 200ms reverse;
}

@keyframes slide {
  0% {
    bottom: -20%;
  }
  100% {
    bottom: 0;
  }
}

@screen md {
  nav section {
    width: 300px;
    @apply h-full px-4;
  }

  @keyframes slide {
    0% {
      left: -20%;
    }
    100% {
      left: 0;
    }
  }

  .search-container {
    @apply flex flex-wrap rounded-none;
    background: transparent;
    order: 2;
  }

  .depth {
    @apply w-1/2 mr-1;
    width: calc(50% - 0.25rem);
    order: 3;
  }

  .subject {
    @apply w-full;
    order: 2;
  }

  .logo {
    @apply mb-4 mt-2 ml-6;
    order: 1;
  }

  .submit {
    @apply w-1/2 ml-1;
    width: calc(50% - 0.25rem);
    order: 4;
  }

  .search-border {
    border: none;
  }

  .search-option {
    @apply rounded-full h-10 mb-4 px-4;
    background-color: white;
  }

  .btn-menu {
    @apply top-0 mt-3 ml-3 h-12 w-12 p-3;
  }
}
</style>
